import React from 'react';
import { Box, Button, Flex, Heading, Table, Text } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { TableLoaderOverlay } from 'shared/components';
import { SavedJobActionsMenu } from './saved-job-actions-menu';
import { useSavedJobs } from './saved-jobs.provider';
import './saved-jobs.scss';

const SavedJobsView = () => {
   const [t] = useTranslation('global');
   const savedJobsStore = useSavedJobs();

   React.useEffect(() => {
      savedJobsStore.init();
      window.scrollTo(0, 0);
   }, [savedJobsStore]);

   return (
      <Box className="candidate-saved-jobs">
         <header className="header">
            <Flex align="center" gap="2">
               <img alt="saved-jobs" src="/Images/employerSide/icon4color.png" />
               <Heading as="h3" size="7" className="heading">
                  {t('jobseekerSavedJobs.savedJobs')}
               </Heading>
            </Flex>
         </header>

         <Box pb="4">
            <Table.Root className="saved-jobs-table" layout="fixed" variant="ghost">
               <Table.Header className="table-header">
                  <Table.Row className="table-header-row">
                     <Table.ColumnHeaderCell
                        className="table-header-cell"
                        width="100px"
                        justify="center"
                        px="5"
                        py="4"
                     >
                        {t('jobseekerSavedJobs.SNo.')}
                     </Table.ColumnHeaderCell>

                     <Table.ColumnHeaderCell className="table-header-cell" px="5" py="4">
                        {t('jobseekerSavedJobs.jobTitle')}
                     </Table.ColumnHeaderCell>

                     <Table.ColumnHeaderCell
                        className="table-header-cell"
                        width="200px"
                        px="5"
                        py="4"
                     >
                        {t('jobseekerSavedJobs.jobType')}
                     </Table.ColumnHeaderCell>

                     <Table.ColumnHeaderCell
                        className="table-header-cell"
                        width="180px"
                        px="5"
                        py="4"
                     >
                        {t('jobseekerSavedJobs.lastDate')}
                     </Table.ColumnHeaderCell>

                     <Table.ColumnHeaderCell
                        className="table-header-cell"
                        width="150px"
                        justify="center"
                        px="5"
                        py="4"
                     >
                        {t('jobseekerSavedJobs.action')}
                     </Table.ColumnHeaderCell>
                  </Table.Row>
               </Table.Header>

               <Table.Body>
                  <TableLoaderOverlay
                     show={savedJobsStore.loadSavedJobsState.status === 'pending'}
                     colSpan={5}
                  />

                  {savedJobsStore.savedJobs.map((savedJob, idx) => (
                     <Table.Row className="table-row" key={savedJob.short_lists_id}>
                        <Table.Cell className="table-cell" justify="center" px="5" py="4">
                           {savedJobsStore.coef + idx}
                        </Table.Cell>

                        <Table.Cell className="table-cell" px="5" py="4">
                           {savedJob.title}
                        </Table.Cell>

                        <Table.Cell className="table-cell" px="5" py="4">
                           {savedJob.work_type}
                        </Table.Cell>

                        <Table.Cell className="table-cell" px="5" py="4">
                           {savedJob.expire_time}
                        </Table.Cell>

                        <Table.Cell className="table-cell action-cell" justify="center" px="5" py="4">
                           <SavedJobActionsMenu savedJob={savedJob} />
                        </Table.Cell>
                     </Table.Row>
                  ))}
               </Table.Body>
            </Table.Root>
         </Box>

         <Flex className="pagination" align="center" justify="center" pt="4" direction="column" gap="2">
            <Flex>
               {savedJobsStore.rawSavedJobs.length > 0 && (
                  <Text color="gray">
                     {t('pagination.NoofRecords')} {savedJobsStore.recordsCount} of{' '}
                     {savedJobsStore.rawSavedJobs.length}
                  </Text>
               )}
            </Flex>

            <Box>
               <Flex align="center" gap="4">
                  <Button
                     radius="small"
                     size="4"
                     disabled={!savedJobsStore.canPrev}
                     onClick={() => {
                        savedJobsStore.onPrev();
                     }}
                  >
                     {t('pagination.Prev')}
                  </Button>

                  <Button
                     radius="small"
                     size="4"
                     disabled={!savedJobsStore.canNext}
                     onClick={() => {
                        savedJobsStore.onNext();
                     }}
                  >
                     {t('pagination.Next')}
                  </Button>
               </Flex>
            </Box>
         </Flex>
      </Box>
   );
};

export const SavedJobs = observer(SavedJobsView);
